import {
  RangeControl,
  ToggleControl,
  __experimentalNumberControl as NumberControl,
  SelectControl,
} from '@wordpress/components';
import {
  ATTRIBUTE_SLIDER_SETTINGS,
  FIELD_TYPES,
} from '@helpers/slider-utils.js';

const {
  i18n: { __ },
} = wp;

const SliderControl = (props) => {
  const {
    sliderSettingsField: field,
    deviceSlug,
    setSliderSettingAttribute,
  } = props;
  let element = null;
  const {
    type: fieldType,
    value: fieldValue,
    name: fieldName,
    onChange: fieldOnChange,
    label: fieldLabel,
    valueFormatter: valueFormatter,
    step: fieldStep,
  } = field;

  const inputValue = valueFormatter ? valueFormatter(fieldValue) : fieldValue;

  const onChange = (newValue) => {
    // eslint-disable-next-line no-unused-expressions
    fieldOnChange
      ? fieldOnChange(deviceSlug, newValue)
      : setSliderSettingAttribute(
          ATTRIBUTE_SLIDER_SETTINGS,
          deviceSlug,
          fieldName,
          '',
          newValue,
        );
  };

  switch (fieldType) {
    case FIELD_TYPES.Range:
      element = (
        <RangeControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          min={field.min}
          max={field.max}
          help={field.help && field.help}
          value={inputValue}
          step={fieldStep ? fieldStep : 1}
          onChange={onChange}
        />
      );
      break;

    case FIELD_TYPES.Toggle:
      element = (
        <ToggleControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          checked={inputValue}
          onChange={onChange}
          help={field.help && field.help}
        />
      );
      break;

    case FIELD_TYPES.Number:
      element = (
        <NumberControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(fieldLabel, 'b3rg')}
          isShiftStepEnabled={typeof fieldStep === 'number'}
          onChange={onChange}
          max={field.max}
          min={field.min}
          step={fieldStep}
          value={inputValue}
        />
      );
      break;

    case FIELD_TYPES.Select:
      element = (
        <SelectControl
          // eslint-disable-next-line @wordpress/i18n-no-variables
          label={__(field.label, 'b3rg')}
          value={inputValue}
          options={field.options}
          onChange={onChange}
        />
      );
      break;

    default:
      break;
  }

  return element;
};

export default SliderControl;
